import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconPositiveSvg } from "./IconPositiveSvg.mjs";
const IconPositive = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconPositiveSvg, ...iconProps });
};
export {
  IconPositive
};
